import {
  UnitChangeType,
  UnitType
} from "../../commom/Enum";

/**
 * 获取计量单位的类型
 */
export class UnitTypeProcessor
{
    static execute(unit){
        if (!unit) {
            return null;
          }
          if (unit.IsSingleUnit) {
            // 单计量
            return UnitType.Single;
          }
          if (unit.ChangeType1.Id == UnitChangeType.Fixed) {
            // 固定多计量
            return UnitType.Fixed;
          }
          if (unit.ChangeType1.Id == UnitChangeType.Float) {
            // 浮动多计量
            return UnitType.Float;
          }
    }

}